<template>
  <myhead>{{$route.meta.title}}</myhead>
  <div class="box">
    <iframe :src="urlSrc" class="fullscreen-iframe"></iframe>
  </div>
</template>

<script setup>
import {ref} from "vue"
const urlSrc = ref("https://as.ff.fj.cn/gD1x");

</script>

<style>
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.fullscreen-iframe {
  width: 100%;
  height: 100%;
  border: none; /* Optional: Remove iframe border */
  overflow: hidden;
}
</style>